<template>
  <div class="content">
    <div class="upload-box" v-if="haveImg">
      <el-upload
        v-loading="loading"
        :limit="1"
        ref="upload"
        :file-list="fileList"
        :action="config.upload"
        accept="image/png,image/jpg,image/jpeg"
        :show-file-list="false"
        :on-success="uploadSuccess"
        :before-upload="beforeAvatarUpload"
      >
        <div v-if="value.imgUrl" class="avatar">
          <img :src="value.imgUrl" />
        </div>
        <div v-else>
          <i class="el-icon-plus avatar-uploader-icon"></i>
          <p class="add-text">添加图片</p>
        </div>
      </el-upload>
      <p
        v-if="!value.imgUrl"
        style="font-size: 12px;color: red;padding-top: 10px;text-align: center;"
      >
        请上传图片
      </p>
    </div>

    <div class="right-content" v-if="!haveSlot">
      <div
        v-if="haveTitle"
        class="component-box"
        :style="{ paddingBottom: haveJump ? '10px' : '0px' }"
      >
        <p>标题</p>
        <!-- pointerdown防止鼠标拖动选中文字时，被冒泡拖拽 -->
        <el-input
          v-model="value.title"
          class="title-input"
          :maxlength="titleMaxLength"
          @pointerdown.stop.native
        />
      </div>

      <p
        v-if="haveTitle && !value.title"
        :style="{
          paddingBottom: haveJump ? '5px' : '0px',
          paddingTop: haveJump ? '0px' : '10px'
        }"
        style="font-size: 12px;color: red;padding-left: 33px;"
      >
        请填写标题
      </p>

      <div class="component-box" v-if="haveJump">
        <SelectJumpLink
          v-if="jumpType === 'url'"
          :path="value.path"
          @change="jumpTypeChange"
        />
        <SelectJumpComponent
          v-if="jumpType === 'component'"
          :path="value.path"
          @change="jumpTypeChange"
        />
      </div>
    </div>
    <slot name="rightContent" v-bind:item="value"></slot>
  </div>
</template>

<script>
import { deepCopy } from "../utils/utils";
import SelectJumpLink from "./SelectJumpLink";
import SelectJumpComponent from "./SelectJumpComponent";
export default {
  props: {
    value: {
      type: Object,
      require: true
    },
    titleMaxLength: {
      type: Number,
      default: 6
    },
    haveImg: {
      type: Boolean,
      default: true
    },
    haveJump: {
      type: Boolean,
      default: true
    },
    haveTitle: {
      type: Boolean,
      default: false
    },
    // url or component
    jumpType: {
      type: String,
      default: "url"
    }
  },
  components: {
    SelectJumpLink,
    SelectJumpComponent
  },
  computed: {
    haveSlot() {
      const keys = Object.keys(this.$slots);
      return keys.length > 0 && keys.some(key => this.$slots[key]);
    }
  },
  data() {
    return {
      fileList: [],
      loading: false
    };
  },
  methods: {
    jumpTypeChange(val) {
      const params = deepCopy(this.value);
      params.path = val;
      this.$emit("input", params);
    },
    uploadSuccess(res) {
      this.loading = false;
      if (res.code === 200) {
        const params = this.value;
        params.imgUrl = res.data;
        this.$emit("input", params);
      } else {
        this.$message.error(res.mes);
      }
      this.fileList = [];
    },

    beforeAvatarUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        console.log(1);
        this.$message.error("上传头像图片大小不能超过 2MB!");
      } else {
        this.loading = true;
      }
      return isLt10M;
    }
  }
};
</script>

<style lang="less" scoped>
.content {
  padding: 10px;
  background: #f7f8fa;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  > .right-content {
    width: 100%;
    > .url-box {
      width: 100%;
      > p {
        font-size: 12px;
        font-weight: 400;
        margin-bottom: 5px;
      }
    }
    > .component-box:first-child {
      padding-bottom: 10px;
    }
    > .component-box,
    .url-box {
      width: 100%;
      display: flex;
      align-items: center;
      /deep/ .title-input {
        flex: 1;
        .el-input__inner {
          height: 30px;
          padding: 0 10px;
          border-radius: 0;
        }
      }
      > p {
        font-size: 12px;
        font-weight: 400;
        margin-right: 10px;
        line-height: 30px;
      }
      /deep/ .select-jump-type {
        flex: 1;
      }
      /deep/ .select-jump-component {
        flex: 1;
      }
    }
  }
  > .upload-box {
    margin-right: 20px;
  }

  /deep/ .el-upload {
    width: 66px;
    height: 66px;
    background: #ffffff;
    border-radius: 4px;
    > div {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    .avatar {
      width: 100%;
      height: 100%;
      position: relative;
      > img {
        width: 100%;
        height: 100%;
      }
      &:hover:after {
        content: "更换图片";
        display: inline-block;
        background: rgba(0, 0, 0, 0.5);
        color: #fff;
        font-size: 10px;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        padding: 3px;
      }
    }
    .avatar-uploader-icon {
      font-size: 14px;
      font-weight: bold;
      color: #2154f4;
      margin-bottom: 4px;
    }
    .add-text {
      font-size: 10px;
      font-weight: 400;
      color: #2154f4;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/components/UploadImgListItem.vue